import React from 'react'
import {Route, Switch} from 'react-router-dom'
import User from './UserContainer'
import UserEdit from './UserEditContainer'

const UserRoute = props => {
  return (
    <div>
      <Switch>
        <Route path={`${props.match.url}/`} exact component={User}/>
        <Route path={`${props.match.url}/edit`} component={UserEdit}/>
      </Switch>
    </div>
  )
}

export default UserRoute
